var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39835 18.2512C9.56247 18.3416 9.74727 18.3879 9.93463 18.3853C10.122 18.3828 10.3055 18.3317 10.4671 18.2369C12.7065 16.9575 16.5984 14.0112 18.1265 10.1844C20.3702 5.20123 15.1027 1.22373 11.4627 4.08436C11.0827 4.38311 10.6052 4.72498 10.2765 5.04811C10.1284 5.19436 9.86648 5.20936 9.7121 5.06936C9.28023 4.67561 8.60523 4.17186 8.17148 3.87873C5.06835 1.77873 -0.578521 4.54686 1.83023 10.4537C2.71273 13.105 6.91773 16.8662 9.39835 18.2512Z",
    fill: "url(#paint0_radial_346_1993)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39835 18.2512C9.56247 18.3416 9.74727 18.3879 9.93463 18.3853C10.122 18.3828 10.3055 18.3317 10.4671 18.2369C12.7065 16.9575 16.5984 14.0112 18.1265 10.1844C20.3702 5.20123 15.1027 1.22373 11.4627 4.08436C11.0827 4.38311 10.6052 4.72498 10.2765 5.04811C10.1284 5.19436 9.86648 5.20936 9.7121 5.06936C9.28023 4.67561 8.60523 4.17186 8.17148 3.87873C5.06835 1.77873 -0.578521 4.54686 1.83023 10.4537C2.71273 13.105 6.91773 16.8662 9.39835 18.2512Z",
    fill: "url(#paint1_radial_346_1993)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39835 18.2512C9.56247 18.3416 9.74727 18.3879 9.93463 18.3853C10.122 18.3828 10.3055 18.3317 10.4671 18.2369C12.7065 16.9575 16.5984 14.0112 18.1265 10.1844C20.3702 5.20123 15.1027 1.22373 11.4627 4.08436C11.0827 4.38311 10.6052 4.72498 10.2765 5.04811C10.1284 5.19436 9.86648 5.20936 9.7121 5.06936C9.28023 4.67561 8.60523 4.17186 8.17148 3.87873C5.06835 1.77873 -0.578521 4.54686 1.83023 10.4537C2.71273 13.105 6.91773 16.8662 9.39835 18.2512Z",
    fill: "url(#paint2_linear_346_1993)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39835 18.2512C9.56247 18.3416 9.74727 18.3879 9.93463 18.3853C10.122 18.3828 10.3055 18.3317 10.4671 18.2369C12.7065 16.9575 16.5984 14.0112 18.1265 10.1844C20.3702 5.20123 15.1027 1.22373 11.4627 4.08436C11.0827 4.38311 10.6052 4.72498 10.2765 5.04811C10.1284 5.19436 9.86648 5.20936 9.7121 5.06936C9.28023 4.67561 8.60523 4.17186 8.17148 3.87873C5.06835 1.77873 -0.578521 4.54686 1.83023 10.4537C2.71273 13.105 6.91773 16.8662 9.39835 18.2512Z",
    fill: "url(#paint3_radial_346_1993)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39835 18.2512C9.56247 18.3416 9.74727 18.3879 9.93463 18.3853C10.122 18.3828 10.3055 18.3317 10.4671 18.2369C12.7065 16.9575 16.5984 14.0112 18.1265 10.1844C20.3702 5.20123 15.1027 1.22373 11.4627 4.08436C11.0827 4.38311 10.6052 4.72498 10.2765 5.04811C10.1284 5.19436 9.86648 5.20936 9.7121 5.06936C9.28023 4.67561 8.60523 4.17186 8.17148 3.87873C5.06835 1.77873 -0.578521 4.54686 1.83023 10.4537C2.71273 13.105 6.91773 16.8662 9.39835 18.2512Z",
    fill: "url(#paint4_radial_346_1993)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39835 18.2512C9.56247 18.3416 9.74727 18.3879 9.93463 18.3853C10.122 18.3828 10.3055 18.3317 10.4671 18.2369C12.7065 16.9575 16.5984 14.0112 18.1265 10.1844C20.3702 5.20123 15.1027 1.22373 11.4627 4.08436C11.0827 4.38311 10.6052 4.72498 10.2765 5.04811C10.1284 5.19436 9.86648 5.20936 9.7121 5.06936C9.28023 4.67561 8.60523 4.17186 8.17148 3.87873C5.06835 1.77873 -0.578521 4.54686 1.83023 10.4537C2.71273 13.105 6.91773 16.8662 9.39835 18.2512Z",
    fill: "url(#paint5_radial_346_1993)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39835 18.2512C9.56247 18.3416 9.74727 18.3879 9.93463 18.3853C10.122 18.3828 10.3055 18.3317 10.4671 18.2369C12.7065 16.9575 16.5984 14.0112 18.1265 10.1844C20.3702 5.20123 15.1027 1.22373 11.4627 4.08436C11.0827 4.38311 10.6052 4.72498 10.2765 5.04811C10.1284 5.19436 9.86648 5.20936 9.7121 5.06936C9.28023 4.67561 8.60523 4.17186 8.17148 3.87873C5.06835 1.77873 -0.578521 4.54686 1.83023 10.4537C2.71273 13.105 6.91773 16.8662 9.39835 18.2512Z",
    fill: "url(#paint6_radial_346_1993)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39835 18.2512C9.56247 18.3416 9.74727 18.3879 9.93463 18.3853C10.122 18.3828 10.3055 18.3317 10.4671 18.2369C12.7065 16.9575 16.5984 14.0112 18.1265 10.1844C20.3702 5.20123 15.1027 1.22373 11.4627 4.08436C11.0827 4.38311 10.6052 4.72498 10.2765 5.04811C10.1284 5.19436 9.86648 5.20936 9.7121 5.06936C9.28023 4.67561 8.60523 4.17186 8.17148 3.87873C5.06835 1.77873 -0.578521 4.54686 1.83023 10.4537C2.71273 13.105 6.91773 16.8662 9.39835 18.2512Z",
    fill: "url(#paint7_radial_346_1993)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39835 18.2512C9.56247 18.3416 9.74727 18.3879 9.93463 18.3853C10.122 18.3828 10.3055 18.3317 10.4671 18.2369C12.7065 16.9575 16.5984 14.0112 18.1265 10.1844C20.3702 5.20123 15.1027 1.22373 11.4627 4.08436C11.0827 4.38311 10.6052 4.72498 10.2765 5.04811C10.1284 5.19436 9.86648 5.20936 9.7121 5.06936C9.28023 4.67561 8.60523 4.17186 8.17148 3.87873C5.06835 1.77873 -0.578521 4.54686 1.83023 10.4537C2.71273 13.105 6.91773 16.8662 9.39835 18.2512Z",
    fill: "url(#paint8_linear_346_1993)",
    fillOpacity: 0.25
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70898 5.06703L9.71148 5.06953C9.86586 5.20953 10.1277 5.19453 10.2759 5.04828C10.5234 4.80516 10.854 4.55203 11.1646 4.31391C11.2679 4.23557 11.3671 4.15932 11.4621 4.08516C15.1021 1.22391 20.369 5.20141 18.1259 10.1845C17.8153 10.9495 17.425 11.6795 16.9615 12.3627L9.70898 5.06703Z",
    fill: "url(#paint9_radial_346_1993)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70898 5.06703L9.71148 5.06953C9.86586 5.20953 10.1277 5.19453 10.2759 5.04828C10.5234 4.80516 10.854 4.55203 11.1646 4.31391C11.2679 4.23557 11.3671 4.15932 11.4621 4.08516C15.1021 1.22391 20.369 5.20141 18.1259 10.1845C17.8153 10.9495 17.425 11.6795 16.9615 12.3627L9.70898 5.06703Z",
    fill: "url(#paint10_radial_346_1993)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_346_1993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1045 6.54885V12.0607C10.1045 12.7095 10.9795 12.9326 11.2707 12.3532C12.1789 10.5482 12.9351 8.55697 12.3195 7.14947C11.8032 5.9701 11.0351 5.84135 10.4339 6.03885C10.2214 6.10885 10.1045 6.3251 10.1045 6.54885Z",
    fill: "url(#paint11_radial_346_1993)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_346_1993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.79098 4.08615C6.31527 4.07977 6.73944 4.00493 6.73839 3.91898C6.73735 3.83304 6.31148 3.76854 5.78719 3.77492C5.26291 3.7813 4.83874 3.85614 4.83978 3.94208C4.84083 4.02803 5.26669 4.09253 5.79098 4.08615Z",
    fill: "url(#paint12_radial_346_1993)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_346_1993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16647 5.82128L9.36209 13.9857C5.06397 9.80565 3.91459 4.91753 5.56147 4.25878C7.20772 3.60065 8.69709 4.84503 9.16584 5.82128",
    fill: "url(#paint13_radial_346_1993)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_346_1993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.51 11.3669C16.3488 11.3669 17.8394 9.76072 17.8394 7.77939C17.8394 5.79807 16.3488 4.19189 14.51 4.19189C12.6713 4.19189 11.1807 5.79807 11.1807 7.77939C11.1807 9.76072 12.6713 11.3669 14.51 11.3669Z",
    fill: "url(#paint14_radial_346_1993)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_346_1993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7721 9.45435C16.1084 11.0556 13.374 14.415 11.4209 15.7043",
    stroke: "#FFC037",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_346_1993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.82617 8.28247C3.56867 11.72 7.27992 14.5712 9.23242 15.8606",
    stroke: "#FAA730",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_346_1993",
    x: 7.85449,
    y: 3.71304,
    width: 6.93848,
    height: 11.2244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125,
    result: "effect1_foregroundBlur_346_1993"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_346_1993",
    x: 3.71484,
    y: 2.64948,
    width: 4.14844,
    height: 2.5621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5625,
    result: "effect1_foregroundBlur_346_1993"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_346_1993",
    x: 2.59277,
    y: 1.82471,
    width: 9.01953,
    height: 14.4109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125,
    result: "effect1_foregroundBlur_346_1993"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_346_1993",
    x: 8.93066,
    y: 1.94189,
    width: 11.1592,
    height: 11.675,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125,
    result: "effect1_foregroundBlur_346_1993"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_346_1993",
    x: 8.7959,
    y: 6.82925,
    width: 10.6016,
    height: 11.5001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125,
    result: "effect1_foregroundBlur_346_1993"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_346_1993",
    x: 0.201172,
    y: 5.65739,
    width: 11.6562,
    height: 12.8282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125,
    result: "effect1_foregroundBlur_346_1993"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_346_1993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.3046 6.09498) rotate(90) scale(14.6875 36.8425)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.114,
    stopColor: "#FFD765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8040"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_346_1993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.4444 5.50924) rotate(116.407) scale(6.32388 5.88349)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD765",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_346_1993",
    x1: 8.51273,
    y1: 10.2162,
    x2: 2.88773,
    y2: 16.2706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#ED7839",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7839"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_346_1993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2781 7.1022) rotate(129.54) scale(14.2448 26.682)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#FF69CF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908,
    stopColor: "#FF69CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_346_1993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8346 11.0169) rotate(-154.151) scale(13.9765 17.0054)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#9B7C23",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B7C23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_346_1993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8348 11.0175) rotate(-152.113) scale(11.3581 10.0459)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#9B7C23",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B7C23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_346_1993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.61273 8.63498) rotate(90) scale(12.3745 16.5174)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#FF69CF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#FF69CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_346_1993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.42085 5.86061) rotate(44.2476) scale(14.7234 41.0058)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#FF69CF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF69CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_346_1993",
    x1: 10.3271,
    y1: 8.12623,
    x2: 9.30461,
    y2: 18.7119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#FF7AF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#FF7AF2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_346_1993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.6296 9.72266) rotate(-59.6724) scale(9.05112 8.48875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#F9861D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA16F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_346_1993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9184 8.12078) rotate(-130.441) scale(6.564 6.673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#C5A34C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#C5A34C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_346_1993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5232 6.36885) rotate(90) scale(11.0547 3.61164)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#FFBF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_346_1993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.01286 3.81597) rotate(-176.498) scale(2.53411 1.04403)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE647",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_346_1993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.3977 6.25128) rotate(-135.564) scale(8.42494 23.7618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE647",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_346_1993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1463 4.19189) rotate(126.781) scale(4.94562 7.95875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE647",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowHeart);
export default __webpack_public_path__ + "static/media/yellow-heart.7a9f277763d8eafe838f0eaddd749271.svg";
export { ForwardRef as ReactComponent };